import { useEffect, useState, useRef } from "react";
import "./UniversityMapsView.scss";
import search from "../../../Assets/Tutor/searchIconGray.svg";
import universityIcon from "../../../Assets/University/universityIcon.svg";
import { useNavigate } from "react-router-dom";
import {
  API_END_POINTS,
  FILTER_CONSTANT,
  GLOBAL_CONSTANTS,
  ROUTES,
  RadiusMapKm,
} from "../../../Constants/Constants";
import { axiosInstance } from "../../../Utilities/Interceptor/Interceptor";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { store } from "../../../Redux/Store/Store";
import { setLoader, setUniversityFilter } from "../../../Redux/Reducer/Reducer";
import {
  GetSessionStorageData,
  SetSessionStorageData,
  isObjectEmptyValue,
  nullUndefinedEmptyCheck,
} from "../../../Utilities/Helpers/Helper";
import UniversityMaps from "../../../Components/UniversityMaps/UniversityMaps";
import UniversityModelDilogView from "../UniversityModelDilogView/UniversityModelDilogView";
import { useSelector } from "react-redux";
import TutorMapRadiusIcon from "../../../Assets/University/university_km.svg";
import AppFilter from "../../../Components/AppFilter.tsx/AppFilter";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import React from 'react';

const containerStyle = {
  width: "100vw",
  height: "100vh",
};

const UniversityMapsView = () => {
  const { t } = useTranslation();
  const University_search = GetSessionStorageData(FILTER_CONSTANT.SEARCH_STATE.UNIVERSITY);
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState(University_search ? University_search : '');
  const [triggerVal, setTriggerVal] = useState(false);
  const [dailogUniversityData, setDailogUniversityData] = useState([]);
  const [UniversityList, setUniversityList] = useState<any>([]);
  const [searchTextList, setSearchTextList] = useState([]);
  const [currentLat, setCurrentLat] = useState<any>("");
  const [currentLang, setCurrentLang] = useState<any>("");
  const [FilterData, setFilterData] = useState<any>([]);
  const [MapZoom, setMapZoom] = useState(12);
  // Placeholder for isLoaded - replace with actual source if managed elsewhere
  const [isLoaded, setIsLoaded] = useState<boolean>(true); // Default to true; adjust based on your logic

  const getUniversityFilter: any = useSelector((state: any) => {
    return state.filterReducer?.universityfilter
  })

  const init_Universityfilter: any = useSelector((state: any) => {
    return state.initFilterReducer.initUniversityfilter
  })

  const init_filter = {
    programs: [],
    price: [0, 0],
    qs_ranking: [0, 0],
    the_ranking: [0, 0],
    sh_ranking: [0, 0],
    language_instruction: [],
    radius: 10,
  }
  const [FilterPopOpen, setFilterPopOpen] = useState(false);
  const [initFilter, setInitFilter] = useState<any>(isObjectEmptyValue(init_Universityfilter) ? init_Universityfilter : init_filter);
  const [FilterApplyData, setFilterApplyData] = useState<any>(init_filter);
  const [radius, setRadius] = useState(init_filter.radius)
  const [initSort, setSort] = useState<any>({
    price: '',
    rating: ''
  });

  const onOpenFilterPop = () => {
    setFilterPopOpen(true);
  };

  const onCloseFilterPop = () => {
    setFilterPopOpen(false);
  };

  const getOneTutor = (data: any) => {
    setDailogUniversityData(data);
    setTriggerVal(true);
  };

  const HeaderLoction: any = useSelector((state: any) => {
    return state.locationReducer.location;
  });

  useEffect(() => {
    if (nullUndefinedEmptyCheck(HeaderLoction?.lat && HeaderLoction?.lng)) {
      setCurrentLat(HeaderLoction?.lat);
      setCurrentLang(HeaderLoction?.lng);
      if (getUniversityFilter && isObjectEmptyValue(getUniversityFilter)) {
        UniversityListApi(HeaderLoction?.lat, HeaderLoction?.lng, searchValue, getUniversityFilter);
      } else {
        UniversityListApi(HeaderLoction?.lat, HeaderLoction?.lng, searchValue, FilterApplyData);
      }
    }
  }, [HeaderLoction]);

  useEffect(() => {
    getFilterData();
  }, []);

  const payload = (latitude: any, longitude: any, value: string, filter: any) => {
    var qsValue: any = [];
    var shValue: any = [];
    var theValue: any = [];
    var priceValue: any = [];

    if (initFilter.price[0] === filter.price[0] && initFilter.price[1] === filter.price[1]) {
      priceValue = []
    } else {
      priceValue = {
        min: filter.price[0],
        max: filter.price[1],
      }
    }
    if (initFilter.qs_ranking[0] === filter.qs_ranking[0] && initFilter.qs_ranking[1] === filter.qs_ranking[1]) {
      qsValue = []
    } else {
      qsValue = {
        min: filter.qs_ranking[0],
        max: filter.qs_ranking[1],
      }
    }
    if (initFilter.sh_ranking[0] === filter.sh_ranking[0] && initFilter.sh_ranking[1] === filter.sh_ranking[1]) {
      shValue = []
    } else {
      shValue = {
        min: filter.sh_ranking[0],
        max: filter.sh_ranking[1],
      }
    }
    if (initFilter.the_ranking[0] === filter.the_ranking[0] && initFilter.the_ranking[1] === filter.the_ranking[1]) {
      theValue = []
    } else {
      theValue = {
        min: filter.the_ranking[0],
        max: filter.the_ranking[1],
      }
    }
    return {
      latitude: latitude?.toString(),
      longitude: longitude?.toString(),
      radius: filter.radius,
      search: value ? value : "",
      price: priceValue,
      qs_ranking: qsValue,
      sh_ranking: shValue,
      the_ranking: theValue,
      programs: filter.programs,
      language_instruction: filter.language_instruction
    };
  };
  const UniversityListApi = (latitude: any, longitude: any, value: string, filter: any) => {
    var pay = payload(latitude, longitude, value, filter);
    axiosInstance
      .post(`${API_END_POINTS.UNIVERSITYLIST}`, pay)
      .then((Response: any) => {
        setUniversityList(Response?.data?.result?.data);
      })
      .catch(() => { });
  };

  const searchUniversityKeyword = (search: any) => {
    var payload = {
      search_text: search,
      latitude: `${currentLat}`,
      longitude: `${currentLang}`,
      radius: radius
    };
    axiosInstance
      .post(`${API_END_POINTS.UNIVERSITY_KEY_WORD_SEARCH}`, payload)
      .then((Response: any) => {
        setSearchTextList(Response?.data.result?.data);
      })
      .catch(() => { });
  };

  const getFilterData = () => {
    axiosInstance
      .get(`${API_END_POINTS.UNIVERSITYFILTERLIST}`)
      .then((Response: any) => {
        if (Response?.data?.status) {
          let data = Response?.data?.result?.data;
          setFilterData(data);
          if (data) {
            let init = {
              programs: [],
              price: [data.price?.min, data.price?.max],
              qs_ranking: [0, 0],
              the_ranking: [0, 0],
              sh_ranking: [0, 0],
              language_instruction: [],
              radius: 10,
            }
            setInitFilter(init);
            SetSessionStorageData(FILTER_CONSTANT.INIT_FILTER.UNIVERSITY, JSON.stringify(init));
            if (getUniversityFilter && isObjectEmptyValue(getUniversityFilter)) {
              setFilterApplyData(getUniversityFilter);
              setRadius(getUniversityFilter.radius);
            } else {
              setFilterApplyData(init);
            }
          }
        }
      })
      .catch(() => { });
  };

  const FilterApply = (filter: any) => {
    setFilterApplyData(filter);
    SetSessionStorageData(FILTER_CONSTANT.STATE_FILTER.SCHOOL, JSON.stringify(filter));
    store.dispatch(setUniversityFilter(filter));
    setRadius(filter.radius);
    UniversityListApi(currentLat, currentLang, searchValue, filter);
  };

  const onInputChange = (value: any) => {
    store.dispatch(setLoader(GLOBAL_CONSTANTS.INITIAL_VALUES.FALSE));
    if (nullUndefinedEmptyCheck(value)) {
      setSearchValue(value);
      SetSessionStorageData(FILTER_CONSTANT.SEARCH_STATE.UNIVERSITY, value);
      if(value.length < 2) {
        searchUniversityKeyword(value);
      }
    }
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    UniversityListApi(currentLat, currentLang, searchValue, FilterApplyData);
  };

  const handleChangeRadiusMapvalue = (value: any) => {
    if (value === 15) {
      setMapZoom(12);
    } else if (value === 50) {
      setMapZoom(10);
    } else if (value === 100) {
      setMapZoom(9);
    } else {
      setMapZoom(12);
    }
    setFilterApplyData({ ...FilterApplyData, radius: FilterApplyData.radius == value ? 10 : value })
  };

  const handleRoutedashboard = () => {
    navigate(ROUTES.UNIVERSITYLAYOUT, {
      state: {
        University_list: UniversityList,
        search_text: searchValue,
        redius: FilterApplyData.radius,
        lat: currentLat,
        lang: currentLang,
        filter: FilterApplyData,
      },
    });
  };

  const getLatAndLong = (lat: string, lang: string) => {
    setCurrentLat(lat);
    setCurrentLang(lang);
  };

  const handleProceedSort = (checkedPrice: any, checkedRating: any) => {
    if (checkedPrice == 'high') {
      const sortedData = [...UniversityList].sort((a: any, b: any) => b?.least_price - a?.least_price);
      setUniversityList(sortedData);
      setSort({
        price: checkedPrice,
        rating: checkedRating
      })
    } else if (checkedPrice == 'low') {
      const sortedData = [...UniversityList].sort((a: any, b: any) => a?.least_price - b?.least_price);
      setUniversityList(sortedData)
      setSort({
        price: checkedPrice,
        rating: checkedRating
      })
    } else if (checkedRating == 'high') {
      const sortedData = [...UniversityList].sort((a: any, b: any) => b?.least_rating - a?.least_rating);
      setUniversityList(sortedData)
      setSort({
        price: checkedPrice,
        rating: checkedRating
      })
    } else if (checkedRating == 'low') {
      const sortedData = [...UniversityList].sort((a: any, b: any) => a?.least_rating - b?.least_rating);
      setUniversityList(sortedData)
      setSort({
        price: checkedPrice,
        rating: checkedRating
      })
    }
  }

  const language: any = useSelector((state: any) => {
    return state.languageReducer.language;
  });

  const Search_icon_top = language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? "search_button_eng" : "search_button_arb";

  // add debounce ref
  const mapDebounceRef = useRef<any>(null);

  // Debounced handler called by UniversityMaps on location change (e.g. drag/drop)
  const handleMapLocationChange = (lat: any, lng: any) => {
    // update UI immediately
    setCurrentLat(lat);
    setCurrentLang(lng);

    // debounce actual API call to avoid many requests during dragging
    if (mapDebounceRef.current) clearTimeout(mapDebounceRef.current);
    mapDebounceRef.current = setTimeout(() => {
      const filterToUse = getUniversityFilter && isObjectEmptyValue(getUniversityFilter) ? getUniversityFilter : FilterApplyData;
      UniversityListApi(lat, lng, searchValue, filterToUse);
    }, 600);
  };

  return (
    <>
      <div className="UniversityMapsView__container">
        <div>
          <UniversityMaps
            zoom={MapZoom}
            radius={FilterApplyData.radius * 1000}
            lat={currentLat}
            lang={currentLang}
            containerStyle={containerStyle}
            disable={false}
            zoomControl={true}
            clickableIcons={true}
            draggable={true}
            getOneTutor={getOneTutor}
            UniversityList={UniversityList}
            initSort={initSort}
            searchValue={searchValue}
            initFilter={initFilter}
            filter={isObjectEmptyValue(getUniversityFilter) ? getUniversityFilter : FilterApplyData}
            language={language}
            isLoaded={isLoaded}
            onLocationChange={handleMapLocationChange} // <-- added
          />
        </div>

        <div className="UniversityCard_position">
          <div
            className="UniversityCard_Img_wapper"
            onClick={() => handleRoutedashboard()}
          >
            <img draggable="false" src={universityIcon} />
            <div className="University__text">{t("Universities")}</div>
          </div>
          <div className="search_field_wrapper">
            <div className="search__autocomplete">
              <form onSubmit={handleSubmit}>
                <Autocomplete
                  freeSolo
                  popupIcon
                  id="free-solo-2-demo"
                  disableClearable={false}
                  clearIcon={false}
                  value={searchValue}
                  onChange={(e, value) => {
                    setSearchValue(value);
                    UniversityListApi(currentLat, currentLang, value, FilterApplyData);
                    SetSessionStorageData(FILTER_CONSTANT.SEARCH_STATE.UNIVERSITY, value);
                  }}
                  options={searchTextList?.map(
                    (option: any) => language === "English" ? option?.university_name : option?.arabic_university_name || option?.university_name
                  )}
                  renderOption={(props, option) => (
                    <Box component='li' sx={[{ px:0.5, py:0.7 }]} {...props} className="notranslate" translate="no">
                      {option}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder={t("Search for University")}
                      onChange={(inputChangeEvent: any) => {
                        onInputChange(inputChangeEvent.target?.value?.trim());
                      }}
                      onKeyDown={(e: any) => {
                        if (e.key === GLOBAL_CONSTANTS.INITIAL_VALUES.ENTER) {
                          e.preventDefault();
                          const trimedvalue = searchValue.trim();
                          if(trimedvalue) {
                            UniversityListApi(currentLat, currentLang, searchValue, FilterApplyData);}
                        }
                      }}
                      InputProps={{
                        ...params.InputProps,
                        type: "text",
                      }}
                    />
                  )}
                />
                <img
                  draggable="false"
                  src={search}
                  alt="search"
                  className={Search_icon_top}
                  onClick={() =>
                    UniversityListApi(currentLat, currentLang, searchValue, FilterApplyData)
                  }
                />
              </form>
            </div>
            <AppFilter
              FilterPopOpen={FilterPopOpen}
              onOpenPop={onOpenFilterPop}
              onClosePop={onCloseFilterPop}
              FilterData={FilterData}
              FilterApply={FilterApply}
              FilterApplyData={FilterApplyData}
              initFilter={initFilter}
              initSort={initSort}
              handleApplySort={handleProceedSort}
              type="university"
              color="#12CC92" />
          </div>
          <div className="TutorCard__RadiusMapKm">
            {RadiusMapKm?.map((item, i) => {
              return (
                <>
                  <div
                    className={
                      FilterApplyData.radius === item.value
                        ? "RadiusMapKm__wapper__active"
                        : "RadiusMapKm__wapper"
                    }
                    key={i}
                    onClick={() => handleChangeRadiusMapvalue(item.value)}
                  >
                    <img src={TutorMapRadiusIcon} alt="" />
                    <span>{item.lable}</span>
                  </div>
                </>
              );
            })}
          </div>
        </div>

        <div>
          <UniversityModelDilogView
            triggerModel={triggerVal}
            Detailes={dailogUniversityData}
            UniversityList={UniversityList}
            close={() => setTriggerVal(false)}
            getLatAndLong={getLatAndLong}
          />
        </div>
      </div>
    </>
  );
};

export default UniversityMapsView;